import { render } from "./SearchSection.vue?vue&type=template&id=3f19b7a5"
import script from "./SearchSection.vue?vue&type=script&lang=js"
export * from "./SearchSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/sufoservices/public_html/admin.sufoservices.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__